import { requestMessagingPrompt } from "@/lib/requestMessagingPrompt";

interface PriceAlertPromptDetails {
  format?: string;
  selectionScope: string;
  surface: string;
}

/** Requests the one-time delivery-channel handoff after confirmed server success. */
export function recordPriceAlertCreated(details: PriceAlertPromptDetails) {
  requestMessagingPrompt({
    reason: "price_alert_created",
    surface: details.surface,
    selectionScope: details.selectionScope,
    format: details.format,
  });
}
